import React from "react";
import Icon from "@Components/Icon";

function SectionHeader({title, description, handleAddItem, label}) {
  return (
    <div className="block__header">
      <h2 className="block__title">{title}</h2>
      <p>{description}</p>
      {handleAddItem && (
        <a href="#" className="block__control" onClick={handleAddItem}>
          <Icon type="add" className="icon icon--inline fill-brand--blue"/>
          {label}
        </a>
      )}
    </div>
  );
}

export default SectionHeader;
